import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getWindowOpacityMenuItems } from './lib'

/**
 * Settings subtitles window opacity menu
 */
export const SettingsSubtitlesWindowOpacityMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesWindowOpacityMenu',
  'window_opacity',
  getWindowOpacityMenuItems
)
